/* global jQuery */
import plugin from "@core/plugins/lib";
import debug from "debug";
const ELEMENT_SELECTOR = "[data-quote-status]";
const PLUGIN_NAME = "quoteStatus";

const log = debug(PLUGIN_NAME);

function getJSONValue(stringValue) {
	try {
		return JSON.parse(stringValue);
	} catch (error) {
		return stringValue;
	}
}

class QuoteStatus {
	constructor(element, options) {
		log("element", element);
		log("options", options);

		this.options = options;
		this.element = element;

		this.frequencies = getJSONValue(this.options.frequencies);
		this.frequency = this.options.frequency;
		this.hospitalName = this.options.hospitalName;
		this.extrasName = this.options.extrasName;
		this.hospitalRates = getJSONValue(this.options.hospitalRates);
		this.extrasRates = getJSONValue(this.options.extrasRates);
		this.noExtras = getJSONValue(this.options.noExtras);

		this.watchAttr = {
			'data-quote-status--frequency': 'frequency',
			'data-quote-status--hospital-name': 'hospitalName',
			'data-quote-status--extras-name': 'extrasName',
			'data-quote-status--hospital-rates': 'hospitalRates',
			'data-quote-status--extras-rates': 'extrasRates',
			'data-quote-status--no-extras': 'noExtras'
		};

		this.attributeObserver = new MutationObserver(
			this.onAttributeChange.bind(this)
		);

		this.hospitalNameElement = this.element.querySelector(
			this.options.hospitalNameSelector
		);

		this.extrasNameElement = this.element.querySelector(
			this.options.extrasNameSelector
		);

		this.extrasPartElement = this.element.querySelector(
			this.options.extrasPartSelector
		);

		this.resultElement = this.element.querySelector(
			this.options.resultSelector
		);

		this.amountElement = this.element.querySelector(
			this.options.amountSelector
		);

		// todo: hide/show = $

		this.init();
		this.watch();
		log("ready", this, this.form);
	}
	init() {}
	watch() {
		log("watching");
		this.attributeObserver.observe(this.element, { attributes: true });
	}

	onAttributeChange(mutationList, observer) {
		mutationList
			.filter(
				function(mutation) {
					return (
						mutation.type === "attributes" &&
						this.watchAttr[mutation.attributeName]
					);
				}.bind(this)
			)
			.forEach(this.applyAttributeChanges.bind(this));
	}

	applyAttributeChanges(mutation) {
		const attribute = mutation.attributeName;
		const newValue = this.element.getAttribute(attribute);
		this[this.watchAttr[attribute]] = getJSONValue(newValue);

		this.updateDisplay();
	}

	updateDisplay() {
		this.hospitalNameElement.textContent = this.hospitalName;
		this.extrasNameElement.textContent = this.extrasName;
		this.amountElement.textContent = this.calculateAmount().toFixed(2);
		this.updateHighlight(this.hospitalNameElement, this.hasHospitalValue.bind(this));
		this.updateHighlight(this.extrasNameElement, this.hasExtrasValue.bind(this));
		this.updateHidden(this.extrasPartElement, ()=> this.noExtras);
		this.updateHidden(this.resultElement, this.hasNoResult.bind(this));
	}

	updateHighlight(element, condition) {
		element.classList.toggle(this.options.highlightClass, condition());
	}

	updateHidden(element, condition) {
		element.hidden = condition();
	}

	calculateAmount() {
		const hospitalAmount = this.getRate(this.hospitalRates);
		const extrasAmount = this.getRate(this.extrasRates);
		return (hospitalAmount + extrasAmount);
	}

	getRate(rates) {
		if(!rates || !rates.length) {
			return 0;
		}
		const frequency = this.frequency;
		// Rates may be a single value e.g. Ambulance only
		const isFixedFrequency = rates.length === 1;
		const frequencyIndex = isFixedFrequency ? 0 : this.frequencies.findIndex((periodName) => {
			return frequency === periodName;
		});
		return rates[frequencyIndex] || 0;
	}

	hasHospitalValue() {
		return !!this.getRate(this.hospitalRates);
	}

	hasExtrasValue() {
		return !!this.getRate(this.extrasRates);
	}

	hasNoResult() {
		return this.calculateAmount() === 0;
	}
}

QuoteStatus.DEFAULTS = {};

plugin(PLUGIN_NAME, QuoteStatus);
jQuery(document).ready(() => {
	jQuery(ELEMENT_SELECTOR)[PLUGIN_NAME]();
});



// WEBPACK FOOTER //
// ./project/client/src/core/modules/cover-selector/components/cover-selector/quote-status.js